import { BiCode, LuFileJson2, MdOutlineCategory, TbFileTypeXml } from '../../../components/react-icons/main';

const mapperIcons = {
  custom: BiCode,
  json: LuFileJson2,
  dataType: MdOutlineCategory,
  xml: TbFileTypeXml
};

export default mapperIcons;
